<template>
  <div
    id="container"
    ref="container"
    style="min-height: 400px; width: 100%"
  ></div>
</template>

<script>
import ECharts from "echarts";

const cores = [
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
];

export default {
  name: "PieChartProdutosMaisVendidos",
  props: {
    dados: {
      type: Array,
    },
  },
  data: () => ({
    myChart: {},
    options: {
      color: cores,
      // tooltip: {},
      grid: {
        left: "5%",
        right: "5%",
        bottom: 10,
        top: 0,
        containLabel: true,
        tooltip: {
          formatter: (params) =>
            params.value
              ? parseFloat(params.value.toFixed(2)).toLocaleString("pt-BR", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                })
              : 0,
        },
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        right: 10,
        top: 35,
        data: [],
        position: "center",
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      series: [
        {
          type: "pie",
          animation: true,
          radius: "55%",
          center: ["35%", "60%"],
          label: {
            normal: {
              show: true,
              // rotate: 90,
              formatter: (params) =>
                params.value
                  ? parseFloat(params.value.toFixed(2)).toLocaleString(
                      "pt-BR",
                      { style: "decimal", minimumFractionDigits: 2 }
                    )
                  : 0,
              fontSize: 12,
              position: "top",
              distance: 1,
              right: "6%",
              top: 10,
            },
          },
          data: [],
        },
      ],
    },
  }),
  mounted() {
    this.init();
    window.addEventListener("resize", this.redimensionar);
  },
  destroy() {
    window.removeEventListener("resize", this.redimensionar);
  },
  methods: {
    init() {
      let dom = this.$refs.container;
      this.myChart = ECharts.init(dom);
      if (this.dados.length > 0) {
        this.myChart.setOption(this.options, true);
      } else {
        return;
      }
    },
    redimensionar() {
      window.onresize = () => {
        this.myChart.resize();
      };
    },
  },
  computed: {
    isMobileDevice: function() {
      return (
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1
      );
    },
  },
  watch: {
    dados: function(val, oldVal) {
      if (val) {
        let valores = val.map((item, i) => {
          if (item) {
            return {
              value: item.Valor,
              name: item.Legenda,
              itemStyle: { color: cores[i] },
            };
          }
        });

        let legenda = val.map((item, i) => {
          if (item) {
            return item.Legenda;
          }
        });

        this.options.series[0].data = valores;
        this.options.legend.data = legenda;

        if (this.isMobileDevice) {
          this.options.grid.left = "5%";
          this.options.grid.right = 0;
          this.options.grid.bottom = "0%";
          this.options.grid.top = "5%";

          this.options.legend.left = 5;
          this.options.legend.top = 0;
          this.options.legend.bottom = 20;

          this.options.series[0].label.normal.show = false;
          this.options.series[0].radius = "75%";
          this.options.series[0].top = "29%";
          this.options.series[0].center = ["50%", "50%"];

          this.options.series[0].label.normal.bottom = "20%";
          this.options.series[0].label.normal.distance = 1;
          this.options.series[0].label.normal.right = "6%";
        }
        this.myChart.setOption(this.options, true);
      }
    },
  },
};
</script>

<style></style>
